export default "__VITE_ASSET__CVZhNqb1__"